import React, { Suspense } from 'react';
import { Container } from 'semantic-ui-react';
import { Sidebar, useProSidebar } from 'react-pro-sidebar';
import { useTranslation } from 'react-i18next';
import { AdminSideBar, AdminNavBar, MessagesButton, Spinner } from '../components';
import { Theme } from '../res';
import AdminStack from '../Routers/AdminStack';


const AdminLayout = ({ user }) => {
    const { collapsed, toggleSidebar, collapseSidebar, broken, toggled } = useProSidebar();
    const { i18n } = useTranslation();
    const isArabic = i18n.language === 'ar';
    const opened = ((broken && toggled) || (!broken && !collapsed));

    const openCloseSideBar = (status) => {
        if (broken) return toggleSidebar(status);
        if (!broken) return collapseSidebar();
    };

    const handleMenuToggle = () => {
        if (broken) {
            toggleSidebar(!toggled);
        } else {
            collapseSidebar();
        }
    };


    return (
        <div style={{ display: 'flex', height: '100vh' }}>
            <MessagesButton user={user} showSidebar={null} />
            <Sidebar 
                collapsedWidth="20%" 
                breakPoint="always" 
                rtl={isArabic}
                style={{ zIndex: 1000 }}
            >
                <AdminSideBar user={user} opened={opened} openCloseSideBar={openCloseSideBar} broken={broken} />
            </Sidebar>
            <main style={{ position: 'relative', display: "flex", flexDirection: 'column', flex: 'auto', backgroundColor: Theme.colors.WHITE, zIndex: 1 }}>
                <AdminNavBar user={user} onMenuToggle={handleMenuToggle} isMenuOpen={opened} />
                <div style={{ width: '100%', padding: 20, overflow: 'auto', flex: 1 }}>
                    <Suspense fallback={<Spinner />}>
                        <Container fluid>
                            <AdminStack />
                        </Container>
                    </Suspense>
                </div>
            </main>
        </div >
    );
};

export default AdminLayout;